import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { StockInEntity } from "./entities/stock-in.entity";
import { StockInController } from "./stock-in.controller";
import { StockInService } from "./stock-in.service";
import {ApplicationExceptionHandler} from '../../../../../packages/backend-utils/src/lib/exception-handling/application-exception-handler'
import { ReportingEntity } from "./entities/reporting.entity";
import { StockOutEntity } from "./entities/stock-out.entity";
import { StockInRepository } from "./repositories/stock-in.repository";
import { MaterialRequestRepository } from "../material-request/material-request-repo";
import { MaterialRequestEntity } from "../material-request/material-request-entity";

@Module({
    imports: [TypeOrmModule.forFeature([StockInEntity,ReportingEntity,StockOutEntity,MaterialRequestEntity])],
    controllers: [StockInController],
    providers: [StockInService, ApplicationExceptionHandler,StockInRepository,MaterialRequestRepository],
})

export class StockInModule { }